import React from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { SidebarModalListItem } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useFont from '@hooks/useFont'

const confirmDelete = (deleteFont, fontPayload) => {
  swal
    .fire({
      title: 'Delete Font Weight?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
      animation: 'slide-from-top',
    })
    .then(({ value }) => {
      if (value){
        deleteFont(fontPayload)
      }
    })
}

const FontListItem = (props) => {
  const { callbacks: { deleteFont }, font } = props
  const { title } = font

  const {
    callbacks: { createOrEditFont, deleteFont: deleteFn },
  } = useFont(font)

  const { isMasterAdmin } = useCurrentUser()

  const fontPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Font Deleted',
  }

  return (
    <SidebarModalListItem title={title}>
      <SidebarModalListItem.Actions>
        <SidebarModalListItem.Icon
          marginRight={isMasterAdmin ? 'medium' : 0}
          onClick={() => createOrEditFont()}
          type="edit"
        />

        {isMasterAdmin && (
          <SidebarModalListItem.Icon onClick={() => confirmDelete(deleteFont, fontPayload)} type="delete" />
        )}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

FontListItem.propTypes = {
  callbacks: PropTypes.shape({
    deleteFont: PropTypes.func.isRequired,
  }).isRequired,
  font: PropTypes.object.isRequired,
}

export default FontListItem
